import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../../assets/shop-banner.jpg';
const _hoisted_1 = {
  key: 0
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "banner"
}, null, -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_card = _resolveComponent("van-card");

  const _component_van_field = _resolveComponent("van-field");

  const _component_van_area = _resolveComponent("van-area");

  const _component_van_popup = _resolveComponent("van-popup");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  const _component_van_submit_bar = _resolveComponent("van-submit-bar");

  const _component_van_form = _resolveComponent("van-form");

  return _ctx.loadComplete ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_van_card, {
    style: {
      "background-color": "#ffffff"
    },
    num: "1",
    tag: " 限购",
    price: _ctx.goods.goods_price,
    desc: _ctx.goods.goods_desc,
    title: _ctx.goods.goods_name,
    thumb: _ctx.goods.goods_img,
    "origin-price": _ctx.goods.goods_line_price
  }, null, 8, ["price", "desc", "title", "thumb", "origin-price"]), _createVNode(_component_van_form, {
    ref: "formRef",
    style: {
      "margin-top": "20px",
      "margin-bottom": "100px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_field, {
        modelValue: _ctx.form.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.form.name = $event),
        name: "name",
        label: "收件人",
        placeholder: "收件人",
        rules: [{
          required: true,
          message: '请填写收件人'
        }]
      }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
        modelValue: _ctx.form.tel,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.tel = $event),
        type: "tel",
        name: "tel",
        label: "手机号",
        maxlength: "11",
        placeholder: "手机号",
        rules: [{
          required: true,
          message: '请填写联系手机号'
        }, {
          validator: _ctx.validator,
          message: '请输入正确手机号'
        }]
      }, null, 8, ["modelValue", "rules"]), _createVNode(_component_van_field, {
        modelValue: _ctx.form.area,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.form.area = $event),
        "is-link": "",
        readonly: "",
        name: "area",
        label: "所在地区",
        placeholder: "请选择所在地区",
        "show-error-message": true,
        rules: [{
          required: true,
          message: '请选择所在地区'
        }],
        onClick: _cache[3] || (_cache[3] = $event => _ctx.showArea = true)
      }, null, 8, ["modelValue"]), _createVNode(_component_van_popup, {
        show: _ctx.showArea,
        "onUpdate:show": _cache[5] || (_cache[5] = $event => _ctx.showArea = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_area, {
          "area-list": _ctx.areaList,
          onConfirm: _ctx.onConfirm,
          onCancel: _cache[4] || (_cache[4] = $event => _ctx.showArea = false)
        }, null, 8, ["area-list", "onConfirm"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_field, {
        modelValue: _ctx.form.detail,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.form.detail = $event),
        name: "detail",
        label: "详细地址",
        placeholder: "详细地址",
        rules: [{
          required: true,
          message: '请填写详细地址'
        }]
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_van_submit_bar, {
      price: _ctx.total_price,
      "text-align": "left",
      onClick: _ctx.onSubmit,
      "button-text": "提交订单",
      "button-color": "#1989fa"
    }, {
      tip: _withCtx(() => [_createTextVNode(" 挪车码限时0元领取，仅需快递费" + _toDisplayString(_ctx.goods.express_price) + "元 ", 1)]),
      _: 1
    }, 8, ["price", "onClick"])]),
    _: 1
  }, 512)])) : _createCommentVNode("", true);
}